import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { Button } from "@mui/material";
import { ConfirmDialog } from "components/ConfirmDialog";

import { useBillOfLadingDiscard } from "./useBillOfLadingDiscard";

const noop = () => undefined;

/**
 * "Discard upload" for a bill of lading that has not been confirmed. Deletes
 * the uploaded document after a confirmation, which removes the bill's row.
 */
export function BillOfLadingDiscardAction({
  documentId,
  onDiscarded,
}: {
  documentId: string;
  onDiscarded: () => void;
}) {
  const discard = useBillOfLadingDiscard({
    onDiscarded,
    cancelRowWatch: noop,
    initialDocumentId: documentId,
  });

  return (
    <>
      <Button
        variant="text"
        color="error"
        startIcon={<DeleteOutline />}
        onClick={discard.requestConfirm}
        disabled={discard.discarding}
      >
        Discard upload
      </Button>
      {discard.confirmOpen && (
        <ConfirmDialog
          open
          onClose={discard.cancelConfirm}
          onConfirm={discard.discard}
          header="Discard this bill of lading?"
          info="The upload and its row are removed. This can't be undone."
          confirmText="Discard"
          loading={discard.discarding}
        />
      )}
    </>
  );
}
